const listButtonHeight = "32px";
const listButtonMinWidth = "110px";
const backgroundDark = "#2b3035";

const button = {
  padding: "9px 20px",
  borderRadius: 0,
};

const listButtonAdd = {
  color: "#fff",
  backgroundColor: backgroundDark,
  borderRadius: 0,
  height: listButtonHeight,
  minWidth: listButtonMinWidth,
  "&:hover": {
    backgroundColor: "#000",
  },
};

const listButtonRemove = {
  borderRadius: 0,
  height: listButtonHeight,
  minWidth: listButtonMinWidth,
};

const cardButtonAdd = {
  ...listButtonAdd,
  width: "100%",
};

const cardButtonRemove = {
  ...listButtonRemove,
  width: "100%",
};

export const styleHelper = {
  button,
  cardButtonAdd,
  cardButtonRemove,
  listButtonAdd,
  listButtonRemove,
};
